const getDaySuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const formatTime = (hours, minutes) => {
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, "0");
  return `${displayHours}:${displayMinutes} ${period}`;
};

const FormatDateDurationForMessagesDate = (
  dateString,
  addTime = false,
  fullFormat = false
) => {
  const currentDate = new Date();
  let str = String(dateString || '').trim().replace(' ', 'T');
  if (str && !str.endsWith('Z') && !str.includes('+')) str += 'Z';
  const messageDate = new Date(str);

  // If fullFormat is true, return the extended format regardless of date
  if (fullFormat) {
    const day = messageDate.getDate();
    const month = messageDate.toLocaleString("en-US", { month: "long" });
    const year = messageDate.getFullYear();
    const daySuffix = getDaySuffix(day);

    let formattedDate = `${day}${daySuffix} ${month} ${year}`;

    if (addTime) {
      const hours = messageDate.getHours();
      const minutes = messageDate.getMinutes();
      formattedDate = `${formattedDate}, ${formatTime(hours, minutes)}`;
    }

    return formattedDate;
  }

  // Check if the message date is today
  if (
    messageDate.getFullYear() === currentDate.getFullYear() &&
    messageDate.getMonth() === currentDate.getMonth() &&
    messageDate.getDate() === currentDate.getDate()
  ) {
    if (addTime) {
      const hours = messageDate.getHours();
      const minutes = messageDate.getMinutes();
      return `Today, ${formatTime(hours, minutes)}`;
    }
    return "Today";
  }

  // Check if the message date is yesterday
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (
    messageDate.getFullYear() === yesterday.getFullYear() &&
    messageDate.getMonth() === yesterday.getMonth() &&
    messageDate.getDate() === yesterday.getDate()
  ) {
    if (addTime) {
      const hours = messageDate.getHours();
      const minutes = messageDate.getMinutes();
      return `Yesterday, ${formatTime(hours, minutes)}`;
    }
    return "Yesterday";
  }

  // Check if the message date is within the past week
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  if (messageDate > oneWeekAgo) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayName = days[messageDate.getDay()];

    if (addTime) {
      const hours = messageDate.getHours();
      const minutes = messageDate.getMinutes();
      return `${dayName}, ${formatTime(hours, minutes)}`;
    }
    return dayName;
  }

  // Check if the message date is within the current year
  if (messageDate.getFullYear() === currentDate.getFullYear()) {
    const month = messageDate.toLocaleString("default", { month: "long" });
    const day = messageDate.getDate();

    if (addTime) {
      const hours = messageDate.getHours();
      const minutes = messageDate.getMinutes();
      return `${month} ${day}, ${formatTime(hours, minutes)}`;
    }
    return `${month} ${day}`;
  }

  // Message date from a previous year
  const month = messageDate.toLocaleString("default", { month: "long" });
  const day = messageDate.getDate();
  const year = messageDate.getFullYear();

  if (addTime) {
    const hours = messageDate.getHours();
    const minutes = messageDate.getMinutes();
    return `${month} ${day} ${year}, ${formatTime(hours, minutes)}`;
  }
  return `${month} ${day} ${year}`;
};

export default FormatDateDurationForMessagesDate;
